var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 241.5 5 L 271 5.5 L 241.5 6 L 241.5 5 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 228.5 6 L 239 6.5 L 220.5 8 L 220.5 7 Q 226.8 8.8 228.5 6 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 273.5 6 L 283.5 6 L 292 7.5 L 284.5 8 L 283.5 7 L 273.5 7 L 273.5 6 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 214.5 8 L 219 8.5 L 209.5 10 L 209.5 9 L 214.5 8 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 293.5 8 L 303 9.5 L 298.5 10 L 293.5 9 L 293.5 8 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 204.5 10 L 208 10.5 L 191.5 14 L 159.5 25 L 127.5 41 Q 96.2 60.2 72 86.5 Q 27.2 132.7 10.5 207 L 10 203.5 Q 18.6 164.1 36 133.5 Q 56.2 98.7 84.5 72 Q 107.3 50.8 135.5 35 L 151.5 27 L 174.5 18 L 204.5 10 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 304.5 10 L 324.5 14 L 343.5 20 L 378.5 36 Q 414 56.5 441 85.5 Q 466.4 113.6 484 149.5 L 497 184.5 L 502 208.5 L 501 208.5 Q 493.6 168.9 477 138.5 Q 455.5 99 423.5 70 Q 402.8 51.2 377.5 37 L 342.5 21 L 316.5 13 L 304.5 11 L 304.5 10 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 235.5 21 L 276.5 21 L 277.5 22 L 292.5 23 L 326.5 31 L 345 38.5 L 343.5 39 L 322.5 31 L 289.5 24 L 272.5 23 L 271.5 22 L 240.5 22 L 239.5 23 L 229.5 23 L 228.5 24 L 215.5 25 L 212.5 27 L 210.5 26 L 185.5 32 L 171.5 37 L 167.5 40 L 166 39.5 L 165.5 41 L 163.5 41 Q 137.1 52.1 115.5 68 Q 94.2 84.2 77 104.5 Q 48.1 138.6 32 185.5 L 26 208.5 L 24 226.5 L 23 227.5 L 23 236.5 L 22 237.5 L 22 270.5 L 23 271.5 L 23 282.5 L 24 283.5 L 26 302.5 L 35 334.5 L 34 334.5 L 25 303.5 L 23 286.5 L 22 285.5 L 22 277.5 L 21 276.5 L 21 233.5 L 22 232.5 L 24 212.5 L 29 191.5 Q 35.5 169.5 45 150.5 Q 67 107 102.5 77 Q 128.2 54.7 161.5 40 L 195.5 28 L 235.5 21 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 234.5 27 L 277.5 27 L 287.5 29 L 296.5 29 L 335.5 40 Q 388.1 60.4 423 98.5 Q 454.1 130.9 472 176.5 L 481 207.5 L 483 224.5 L 484 225.5 Q 482.3 231.8 485 233.5 L 485 277.5 L 484 278.5 L 482 299.5 L 477 320.5 Q 469.2 346.2 457 367.5 L 438 396.5 L 409.5 427 Q 373.2 460.2 320.5 477 L 299.5 482 L 278.5 484 L 277.5 485 L 234.5 485 L 233.5 484 L 212.5 482 L 198.5 478 L 194.5 478 L 173.5 471 L 171.5 469 L 168.5 469 L 144.5 457 L 119.5 441 L 88 412.5 L 86 409.5 Q 56.7 378.8 40 335.5 L 34 317.5 L 28 286.5 Q 29.7 280.3 27 278.5 L 27 233.5 L 28 232.5 L 30 212.5 L 36 187.5 L 45 164.5 L 55 144.5 L 77 111.5 L 101.5 86 Q 128.5 61 164.5 45 L 198.5 33 L 211.5 31 L 215.5 29 L 224.5 29 L 234.5 27 Z M 241 28 L 240 29 L 230 29 L 229 30 L 221 30 L 215 32 L 210 32 L 187 38 L 168 45 Q 132 60 106 84 Q 71 114 50 157 L 36 194 L 31 216 L 30 229 L 29 230 L 29 239 L 28 240 L 28 273 L 29 274 L 29 283 L 30 284 L 30 291 L 33 307 L 38 326 L 45 345 L 57 369 Q 69 390 85 408 Q 115 442 159 463 L 194 476 L 216 481 L 229 482 L 230 483 L 240 483 L 241 484 L 272 484 L 273 483 L 291 482 L 307 479 L 332 472 Q 375 456 407 428 Q 441 398 462 356 L 476 319 L 481 297 L 482 284 L 483 283 L 483 274 L 484 273 L 484 241 L 483 240 L 482 222 L 476 194 L 470 176 Q 454 135 427 105 Q 394 67 345 45 L 319 36 L 292 30 L 273 29 L 272 28 L 241 28 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 346.5 39 Q 394.6 58.9 427 94.5 Q 458.4 126.6 476 172.5 L 483 193.5 L 489 221.5 L 490 239.5 L 491 240.5 L 491 275.5 L 490 276.5 L 489 292.5 L 484 315.5 L 470 354.5 Q 448.8 399.8 413.5 431 Q 384.8 457.8 345.5 474 L 303.5 487 L 285.5 489 L 284.5 490 L 277.5 490 L 276.5 491 L 256.5 491 L 255.5 492 L 254.5 491 L 235.5 491 L 234.5 490 L 226.5 490 L 225.5 489 L 208.5 487 L 195.5 484 L 161.5 472 Q 111.5 449.5 78 410.5 Q 50.2 379.8 35 336.5 L 36 336.5 Q 58.5 396.5 103.5 434 Q 132.8 459.2 171.5 475 L 196.5 483 L 221.5 488 L 238.5 489 L 239.5 490 L 271.5 490 L 272.5 489 L 289.5 488 L 315.5 483 L 347.5 472 L 374.5 458 L 394.5 445 Q 415.7 429.2 433 409.5 Q 448.8 391.3 461 369.5 L 476 337.5 L 482 318.5 L 488 290.5 L 489 271.5 L 490 270.5 L 490 245.5 L 489 244.5 L 489 232.5 L 488 231.5 L 488 224.5 L 487 223.5 L 485 206.5 L 473 167.5 L 453 129.5 L 429 98 Q 426.3 99.1 427 96.5 L 419 90 L 419 88 Q 416.3 89.1 417 86.5 L 394.5 67 L 363.5 48 L 347.5 41 L 346.5 39 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 9.5 208 L 10 212.5 L 8.5 218 L 8 213.5 L 9.5 208 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 502.5 210 L 504 221.5 L 503 221.5 L 502.5 210 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 7.5 219 L 8 225.5 L 7 225.5 L 7.5 219 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 504.5 223 L 505 229.5 L 504 229.5 L 504.5 223 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 6.5 227 L 7 235.5 L 6 235.5 L 6.5 227 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 505.5 231 L 506 242.5 L 505 242.5 L 505.5 231 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 5.5 239 L 6 270.5 L 5 270.5 L 5.5 239 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 506.5 246 L 507 270.5 L 506 270.5 L 506.5 246 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 6.5 273 L 7 283.5 L 6 283.5 L 6.5 273 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 505.5 273 L 506 282.5 L 505 282.5 L 505.5 273 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 504.5 284 L 505 290.5 L 504 290.5 L 504.5 284 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 7.5 285 L 8 290.5 L 7 290.5 L 7.5 285 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 8.5 292 L 10 302.5 L 9 302.5 L 8.5 292 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 503.5 292 L 504 297.5 L 495 334.5 L 488 353.5 L 478 374.5 Q 458.3 409.8 430.5 437 Q 401.1 465.1 362.5 484 L 327.5 497 L 307.5 502 L 292.5 504 L 292.5 503 L 307.5 501 L 326.5 496 Q 350.8 488.8 371.5 478 Q 411 457 440 425.5 Q 465 398.5 482 363.5 L 495 330.5 L 500 312.5 L 503.5 292 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 10.5 304 Q 18.9 345.6 37 377.5 Q 58 414.5 88.5 442 Q 116 467.5 152.5 484 L 184.5 496 L 213 502.5 L 208.5 503 L 194.5 499 L 190.5 499 L 173.5 493 Q 172 495.5 170.5 492 L 167.5 491 L 166 491.5 Q 166.8 488.9 163.5 490 Q 107.5 467 70 425.5 L 53 404.5 L 45 391 Q 42 392.3 43 388.5 L 36 378.5 L 20 343.5 L 10 308.5 L 10.5 304 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 214.5 503 L 219 503.5 L 214.5 504 L 214.5 503 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 220.5 504 L 227 504.5 L 220.5 505 L 220.5 504 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 284.5 504 L 291 504.5 L 284.5 505 L 284.5 504 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 228.5 505 L 238 505.5 L 230.5 507 L 228.5 505 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 273.5 505 L 283 505.5 L 273.5 506 L 273.5 505 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,205,91)",
    stroke: "rgb(244,205,91)",
    strokeWidth: 1,
    opacity: 0.4745098039215686,
    d: "M 240.5 506 L 272 506.5 L 240.5 507 L 240.5 506 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 77.5 266 L 84 266 L 84 269.5 L 85 270.5 L 85 284.5 L 82.5 288 Q 79.2 291.2 71.5 290 L 66 285.5 Q 63.2 280.9 64 274 L 56 275 L 55 269 L 67.5 268 L 68.5 267 L 76.5 267 L 77.5 266 Z M 72 273 L 70 275 L 71 283 Q 72 285 78 284 L 80 279 L 80 275 Q 78 271 72 273 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 453.5 266 Q 458.3 264.3 457 268.5 L 456 272 L 450 273 L 448 287 L 454 290.5 L 453 296 L 426 281 Q 424.5 275.6 427.5 274 L 453.5 266 Z M 444 275 L 434 279 L 443 284 L 444 278 L 444 275 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 85.5 293 Q 88.8 291.9 88 294.5 L 89 299 L 68.5 304 L 67 305.5 L 69 317 L 65.5 318 L 62 311.5 L 60 300 L 85.5 293 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 431.5 296 Q 443.1 295.9 447 303.5 L 449 312.5 L 445 327 L 418.5 320 L 416 317.5 L 421 303.5 L 426.5 298 L 431.5 296 Z M 433 302 L 430 303 L 425 308 L 423 315 L 441 320 L 443 313 L 442 307 Q 440 303 436 303 L 433 302 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 66 322 L 96.5 322 L 99 324.5 L 99 328.5 L 78.5 350 Q 76.3 350.8 77 348.5 L 75 345.5 L 80 338.5 L 74.5 328 Q 68.5 329.5 67 326.5 L 66 322 Z M 81 328 L 83 334 L 85 335 L 91 329 L 81 328 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 410.5 332 L 415.5 333 L 417.5 333 L 428.5 333 L 429.5 334 L 431.5 334 L 439.5 334 L 441 335.5 L 438.5 340 L 431.5 340 L 431 341.5 L 426 352.5 L 430 357.5 L 427.5 361 L 422 356.5 L 407 336.5 L 410.5 332 Z M 416 338 L 416 341 L 422 347 L 425 339 L 416 338 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 103.5 339 L 107 341.5 L 117 357.5 L 112.5 361 L 107.5 354 L 87 366 L 85 361.5 L 104 348.5 L 100 341.5 L 103.5 339 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 400.5 352 Q 408.8 349.5 406 357 Q 400.4 357.1 398 361.5 L 397 368.5 L 400.5 374 L 409.5 375 L 413 373 L 416.5 363 Q 423.7 360.7 421 368.5 Q 419.4 375.4 414.5 379 L 407.5 382 L 398.5 380 L 393 374.5 Q 390.1 370.9 391 363.5 Q 392.5 357 397.5 354 L 400.5 352 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 124.5 367 Q 128.8 367.8 128 373.5 L 116 400 L 112 397.5 L 111 394.5 Q 113.6 393.1 113 388.5 L 105.5 380 L 97.5 381 L 95 377.5 L 96.5 376 L 124.5 367 Z M 118 375 L 111 377 L 117 384 L 120 377 Q 121 374 118 375 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 381.5 373 L 402 392.5 Q 402.5 396.5 399.5 397 Q 395.5 397.5 395 394.5 Q 395.8 392.3 393.5 393 L 379.5 379 L 378 379 Q 377.3 374.3 381.5 373 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 373.5 381 Q 376.8 379.9 376 382.5 L 378 384.5 L 371.5 391 L 368 393.5 L 372.5 399 L 381.5 391 L 385 394.5 L 384 395.5 Q 384.8 397.8 382.5 397 L 376 402 L 382 410.5 L 382 412.5 Q 381.5 415.5 377.5 415 L 360 393.5 L 373.5 381 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 139.5 383 L 154 394.5 Q 154.5 398.5 151.5 399 L 140.5 391 L 137 396.5 L 145 403.5 Q 145.5 407.5 142.5 408 L 132.5 401 L 125.5 409 L 122 407 L 121 404.5 L 139.5 383 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 352.5 398 Q 355.8 396.9 355 399.5 L 369 419.5 L 369 421.5 Q 368.5 424.5 364.5 424 L 349 400.5 L 352.5 398 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 156.5 402 L 165.5 402 L 174 408.5 Q 178 412 177 420.5 L 169.5 430 Q 166.2 432.7 159.5 432 L 155.5 430 L 148 424.5 Q 144.7 420.8 146 412.5 L 153.5 403 L 156.5 402 Z M 158 408 L 156 409 L 152 415 L 153 422 L 159 426 Q 165 427 168 424 L 171 419 L 170 413 Q 168 406 158 408 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 341.5 405 L 344 406.5 L 356 430.5 Q 354.6 433.6 349.5 433 L 331.5 423 L 331 425.5 L 338 439.5 L 332 442 L 332 439.5 L 320 416.5 L 325.5 413 L 345 423 L 338 407.5 L 341.5 405 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 186.5 413 L 199.5 418 L 205 423.5 Q 206.4 433.9 200.5 437 L 197 438 L 199 449 Q 194.1 449.1 192 445.5 L 191 438.5 L 189.5 437 L 184.5 435 L 180.5 443 L 176 440.5 L 183 419.5 L 186.5 413 Z M 189 421 L 186 430 Q 190 433 198 432 L 199 426 Q 196 421 189 421 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 312.5 418 L 316 419.5 L 320 434.5 L 320 442.5 L 315.5 448 L 305.5 451 L 297 447 L 290 425.5 L 295.5 424 L 297 425.5 L 301 441.5 L 303.5 444 L 307.5 445 L 313 443 Q 314.6 440.9 314 435.5 L 309 420.5 L 312.5 418 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 214.5 423 L 220 425.5 L 225.5 443 L 236 427 L 243 428 L 239 457 L 233 456 L 235 440.5 L 233 441.5 L 225.5 452 L 222 450.5 L 217.5 436 L 216 437.5 L 214 453 L 208 451.5 L 209 448.5 L 210 444.5 L 210 442.5 L 211 437.5 L 211 435.5 L 212 432.5 L 212 430.5 Q 211.2 424.7 214.5 423 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,206,99)",
    stroke: "rgb(243,206,99)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 258 428 Q 264.3 426.5 266 430.5 L 277 457 L 271.5 457 L 271 455.5 L 269 451 L 255.5 451 L 255 452.5 L 253 457 L 248.5 458 L 247 454.5 L 258 428 Z M 262 436 L 258 445 L 266 445 L 262 436 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 512 0 L 512 512 L 0 512 L 0 0 Z M 242 5 L 241 6 L 221 7 L 200 11 L 181 16 L 159 24 L 124 42 Q 102 55 85 72 Q 48 106 26 154 Q 17 174 11 199 L 7 220 L 6 239 L 5 240 L 6 284 L 7 285 L 10 309 L 15 329 Q 25 363 43 389 Q 42 392 45 391 L 53 405 L 70 426 Q 107 467 164 490 Q 167 489 166 492 L 168 491 L 171 492 Q 172 495 174 493 L 191 499 L 230 506 L 232 506 L 240 506 L 241 507 L 272 507 L 273 506 L 291 505 L 317 500 L 341 493 L 363 484 L 384 473 Q 409 457 431 437 Q 463 405 484 363 L 495 335 L 501 313 L 505 291 L 505 284 L 506 283 L 506 272 L 507 271 L 507 247 L 506 246 L 506 232 L 504 223 L 504 216 L 499 192 L 491 167 Q 483 146 473 129 Q 459 105 441 86 Q 405 47 354 24 L 325 14 L 298 8 L 285 7 L 284 6 L 272 6 L 271 5 L 242 5 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 240.5 22 L 271.5 22 L 272.5 23 L 289.5 24 L 322.5 31 L 345.5 39 L 382.5 59 Q 401.7 70.8 417 86.5 Q 416.3 89.1 419 88 L 419 90 L 420.5 90 L 427 98 Q 429.7 96.9 429 99.5 Q 443.1 112.4 453 129.5 L 475 172.5 L 483 197.5 L 487 217.5 L 488 231.5 L 489 232.5 L 489 244.5 L 490 245.5 L 490 270.5 L 489 271.5 L 488 290.5 L 482 318.5 L 476 337.5 L 468 355.5 Q 455.7 381.2 439 402.5 L 410.5 432 L 384.5 452 L 367.5 462 L 337.5 476 L 315.5 483 L 289.5 488 L 272.5 489 L 271.5 490 L 239.5 490 L 238.5 489 L 229.5 489 L 228.5 488 L 209.5 486 L 189.5 481 Q 163.5 473.5 142.5 461 Q 104.3 439.7 77 407.5 Q 50.9 376.6 35 335.5 L 28 311.5 L 24 290.5 L 23 271.5 L 22 270.5 L 22 237.5 L 23 236.5 L 23 227.5 L 24 226.5 L 26 208.5 L 32 185.5 L 38 168.5 L 52 140.5 Q 73.3 102.8 105.5 76 Q 131.6 54.6 164.5 40 L 166 40.5 L 166.5 39 Q 168 41.5 169.5 38 L 185.5 32 L 211.5 26 L 213.5 26 L 229.5 23 L 239.5 23 L 240.5 22 Z M 235 27 L 225 29 L 216 29 L 212 31 L 199 33 L 165 45 Q 128 61 102 86 L 77 112 L 55 145 L 45 165 L 36 188 L 30 213 L 28 233 L 27 234 L 27 279 Q 30 280 28 287 L 34 318 L 40 336 Q 57 379 86 410 L 88 413 L 120 441 L 145 457 L 169 469 L 172 469 L 174 471 L 195 478 L 199 478 L 213 482 L 234 484 L 235 485 L 278 485 L 279 484 L 300 482 L 321 477 Q 373 460 410 427 L 438 397 L 457 368 Q 469 346 477 321 L 482 300 L 484 279 L 485 278 L 485 234 Q 482 232 484 226 L 483 225 L 481 208 L 472 177 Q 454 131 423 99 Q 388 60 336 40 L 297 29 L 288 29 L 278 27 L 235 27 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 6 L 272.5 6 L 273.5 7 L 292.5 8 L 316.5 13 L 352.5 25 Q 406.2 47.8 442 88.5 Q 472.4 121.6 490 167.5 L 498 192.5 L 503 215.5 L 504 229.5 L 505 230.5 L 505 242.5 L 506 243.5 L 506 272.5 L 505 273.5 L 504 291.5 L 499 316.5 L 494 333.5 L 482 363.5 Q 460.8 406.8 427.5 438 Q 393.3 471.3 344.5 490 L 319.5 498 L 291.5 504 L 273.5 505 L 272.5 506 L 238.5 506 L 237.5 505 L 227.5 505 L 226.5 504 L 213.5 503 L 191.5 498 L 152.5 484 Q 103.7 461.3 70 423.5 Q 37.7 388.8 20 339.5 L 11 308.5 L 8 285.5 L 7 284.5 L 7 273.5 L 6 272.5 L 6 236.5 L 7 235.5 L 8 218.5 L 13 194.5 L 28 152.5 Q 50.7 103.7 88.5 70 Q 118.6 42.1 159.5 25 L 199.5 12 L 219.5 8 L 238.5 7 L 239.5 6 Z M 236 21 L 196 28 L 162 40 Q 128 55 103 77 Q 67 107 45 151 Q 35 169 29 192 L 24 213 L 22 233 L 21 234 L 21 277 L 22 278 L 22 286 L 23 287 L 25 304 L 31 327 Q 47 376 78 411 Q 112 449 162 472 L 196 484 L 209 487 L 226 489 L 227 490 L 235 490 L 236 491 L 255 491 L 256 492 L 257 491 L 277 491 L 278 490 L 285 490 L 286 489 L 304 487 L 346 474 Q 385 458 414 431 Q 449 400 470 355 L 484 316 L 489 293 L 490 277 L 491 276 L 491 241 L 490 240 L 489 222 L 483 194 L 476 173 Q 458 127 427 95 Q 391 56 338 35 L 320 29 L 293 23 L 278 22 L 277 21 L 236 21 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 28 L 271.5 28 L 272.5 29 L 291.5 30 L 318.5 36 L 344.5 45 Q 393.8 66.7 427 104.5 Q 454 134.5 470 175.5 L 476 193.5 L 482 221.5 L 483 239.5 L 484 240.5 L 484 272.5 L 483 273.5 L 483 282.5 L 482 283.5 L 481 296.5 L 476 318.5 L 462 355.5 Q 440.6 398.1 406.5 428 Q 375 456 331.5 472 L 306.5 479 L 290.5 482 L 272.5 483 L 271.5 484 L 240.5 484 L 239.5 483 L 229.5 483 L 228.5 482 L 215.5 481 L 193.5 476 L 158.5 463 Q 115.2 441.8 85 407.5 Q 69.2 389.8 57 368.5 L 45 344.5 L 38 325.5 L 33 306.5 L 30 290.5 L 30 283.5 L 29 282.5 L 29 273.5 L 28 272.5 L 28 239.5 L 29 238.5 L 29 229.5 L 30 228.5 L 31 215.5 L 36 193.5 L 50 156.5 Q 71.4 113.9 105.5 84 Q 132.5 60.5 167.5 45 L 186.5 38 L 209.5 32 L 214.5 32 L 220.5 30 L 228.5 30 L 229.5 29 L 239.5 29 L 240.5 28 Z M 243 52 L 239 53 L 240 58 L 239 62 L 241 67 L 241 76 L 242 77 L 241 80 L 237 83 L 232 82 L 229 79 L 227 57 L 226 54 Q 223 56 217 55 L 215 57 L 217 79 L 219 85 Q 222 90 229 92 Q 240 94 246 90 Q 251 87 253 80 L 253 70 L 251 60 L 251 52 L 243 52 Z M 284 53 L 275 55 L 270 58 Q 264 62 263 70 Q 262 80 266 85 Q 271 91 279 93 Q 293 95 298 89 L 298 87 L 293 81 L 287 84 Q 281 85 279 82 L 275 78 Q 274 70 277 67 L 281 64 Q 292 62 295 69 L 300 66 L 302 63 L 297 57 L 284 53 Z M 318 61 L 311 75 Q 312 78 310 77 L 310 79 L 303 97 L 316 102 Q 319 101 318 104 L 320 103 L 332 108 L 335 100 L 317 93 L 320 87 L 332 92 L 335 92 L 337 84 L 323 79 Q 322 75 325 74 L 342 80 L 344 71 L 318 61 Z M 187 64 L 168 71 L 169 77 L 182 107 L 192 103 L 189 95 L 199 90 Q 204 87 206 81 L 206 76 L 203 69 Q 199 62 187 64 Z M 241 115 L 219 119 L 202 125 Q 176 135 159 153 Q 141 169 130 191 L 119 219 L 115 239 L 115 272 L 116 273 L 117 285 L 122 303 L 134 329 L 154 355 L 175 372 L 193 383 L 216 392 L 241 397 L 272 397 L 296 392 Q 327 383 349 363 Q 375 342 388 308 L 396 279 Q 394 272 397 271 L 397 245 L 397 243 L 392 217 L 386 200 Q 375 175 357 157 Q 335 134 303 122 L 290 118 L 273 115 L 241 115 Z M 78 266 L 77 267 L 69 267 L 68 268 L 55 269 L 56 275 L 64 274 Q 63 281 66 286 L 72 290 Q 79 291 83 288 L 85 285 L 85 271 L 84 270 L 84 266 L 78 266 Z M 454 266 L 428 274 Q 424 276 426 281 L 453 296 L 454 291 L 448 287 L 450 273 L 456 272 L 457 269 Q 458 264 454 266 Z M 86 293 L 60 300 L 62 312 L 66 318 L 69 317 L 67 306 L 69 304 L 89 299 L 88 295 Q 89 292 86 293 Z M 432 296 L 427 298 L 421 304 L 416 318 L 419 320 L 445 327 L 449 313 L 447 304 Q 443 296 432 296 Z M 66 322 L 67 327 Q 68 329 75 328 L 80 339 L 75 346 L 77 349 Q 76 351 79 350 L 99 329 L 99 325 L 97 322 L 66 322 Z M 411 332 L 407 337 L 422 357 L 428 361 L 430 358 L 426 353 L 431 342 L 432 340 L 439 340 L 441 336 L 440 334 L 432 334 L 430 334 L 429 333 L 418 333 L 416 333 L 411 332 Z M 104 339 L 100 342 L 104 349 L 85 362 L 87 366 L 108 354 L 113 361 L 117 358 L 107 342 L 104 339 Z M 401 352 L 398 354 Q 393 357 391 364 Q 390 371 393 375 L 399 380 L 408 382 L 415 379 Q 419 375 421 369 Q 424 361 417 363 L 413 373 L 410 375 L 401 374 L 397 369 L 398 362 Q 400 357 406 357 Q 409 350 401 352 Z M 125 367 L 97 376 L 95 378 L 98 381 L 106 380 L 113 389 Q 114 393 111 395 L 112 398 L 116 400 L 128 374 Q 129 368 125 367 Z M 382 373 Q 377 374 378 379 L 380 379 L 394 393 Q 396 392 395 395 Q 395 398 400 397 Q 402 397 402 393 L 382 373 Z M 374 381 L 360 394 L 378 415 Q 382 416 382 413 L 382 411 L 376 402 L 383 397 Q 385 398 384 396 L 385 395 L 382 391 L 373 399 L 368 394 L 372 391 L 378 385 L 376 383 Q 377 380 374 381 Z M 140 383 L 121 405 L 122 407 L 126 409 L 133 401 L 143 408 Q 146 408 145 404 L 137 397 L 141 391 L 152 399 Q 155 399 154 395 L 140 383 Z M 353 398 L 349 401 L 365 424 Q 369 425 369 422 L 369 420 L 355 400 Q 356 397 353 398 Z M 157 402 L 154 403 L 146 413 Q 145 421 148 425 L 156 430 L 160 432 Q 166 433 170 430 L 177 421 Q 178 412 174 409 L 166 402 L 157 402 Z M 342 405 L 338 408 L 345 423 L 346 424 L 326 413 L 320 417 L 332 440 L 332 442 L 338 440 L 331 426 L 332 423 L 350 433 Q 355 434 356 431 L 344 407 L 342 405 Z M 187 413 L 183 420 L 176 441 L 181 443 L 185 435 L 190 437 L 191 439 L 192 446 Q 194 449 199 449 L 197 438 L 201 437 Q 206 434 205 424 L 200 418 L 187 413 Z M 313 418 L 309 421 L 314 436 Q 315 441 313 443 L 308 445 L 304 444 L 301 442 L 297 426 L 296 424 L 290 426 L 297 447 L 306 451 L 316 448 L 320 443 L 320 435 L 316 420 L 313 418 Z M 215 423 Q 211 425 212 431 L 212 433 L 211 436 L 211 438 L 210 443 L 210 445 L 209 449 L 208 452 L 214 453 L 216 438 L 218 436 L 222 451 L 226 452 L 235 439 L 236 439 L 233 456 L 239 457 L 243 428 L 236 427 L 226 443 L 220 426 L 215 423 Z M 258 428 L 247 455 L 249 458 L 253 457 L 255 453 L 256 451 L 269 451 L 271 456 L 272 457 L 277 457 L 266 431 Q 264 426 258 428 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 74 Q 192.8 72.8 194 76.5 L 194 78.5 Q 194.5 82.5 191.5 83 L 185 85 L 182 76.5 L 186.5 74 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 208 L 247.5 222 L 262.5 223 L 271.5 225 L 297.5 225 L 298.5 224 L 306.5 224 L 318.5 221 L 323.5 221 L 340.5 216 L 340.5 217 L 332.5 219 L 322.5 226 L 318.5 226 L 314.5 225 L 311.5 230 L 302 234.5 Q 302.9 237.9 297.5 236 Q 296.3 238.3 291.5 237 L 290 236.5 Q 290.8 239.1 287.5 238 L 282.5 242 L 266.5 243 L 260.5 241 L 246.5 240 L 232.5 236 Q 215.6 229.4 203 218.5 L 206 211.5 L 205.5 208 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 216 L 349.5 216 L 358 218.5 L 358 220.5 L 357 228 L 347 229.5 L 351 231.5 L 348 233 L 344.5 239 L 335.5 241 Q 335 237.5 330.5 238 L 328 239 L 329 234.5 L 327 235.5 Q 327.8 237.8 325.5 237 L 323.5 236 Q 309.3 240.8 298.5 249 L 291.5 251 L 287.5 255 L 283.5 255 L 277.5 258 L 264.5 261 L 259.5 260 Q 258 262.5 252.5 261 L 248.5 260 L 246.5 260 L 240.5 260 L 221.5 254 L 206.5 245 L 200 238.5 L 195 229.5 L 195 225.5 Q 196.8 227.1 198.5 224 L 201.5 224 Q 216.8 236.2 237.5 243 L 253.5 246 L 280.5 246 L 302.5 241 L 322.5 234 L 331.5 229 L 341 227 L 340 221 L 345 218.5 L 342.5 216 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 233 L 153 234.5 L 146.5 245 L 146 243.5 Q 147.8 236.3 153.5 233 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362 234 L 364 234.5 L 362 235.5 L 362 234 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 236 L 195 241.5 L 209.5 257 Q 219.4 265.6 232.5 271 L 245.5 275 L 250.5 275 L 252 276.5 Q 251.3 278.8 253.5 278 L 262.5 276 L 275 276 L 271.5 281 L 269.5 282 Q 258.8 280.3 252.5 283 Q 250.8 280.3 244.5 282 L 243 280.5 Q 244.3 276.8 240.5 278 L 241 279.5 L 239.5 282 L 235.5 282 L 222.5 278 L 226.5 283 L 235 288.5 L 231.5 290 Q 227 290.5 226.5 287 L 224.5 290 L 209.5 282 L 204 281 L 204 277 L 202.5 277 L 198 273.5 L 196 266 Q 193.3 267.1 194 264.5 L 193 261 L 188 257.5 L 184.5 251 Q 176.3 252.1 173 250 L 173 245 L 174.5 245 L 173 242.5 L 175.5 237 L 185.5 241 L 188.5 236 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 238 L 161 240.5 Q 162.5 244.9 159.5 244 L 158 246.5 L 159 251 L 155.5 250 L 153.5 253 L 151 251.5 L 150 243.5 L 155.5 238 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 242 Q 361.8 241.3 361 243.5 L 353.5 257 L 351 256.5 L 352.5 254 Q 355.8 255.1 355 252.5 Q 358 249.3 357 243 L 359.5 242 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 264 L 327.5 264 L 328 265.5 Q 331 266.8 330 271 L 327.5 272 L 307.5 273 L 305.5 272 L 301.5 273 L 299.5 273 L 293 275 Q 291.9 272.3 294.5 273 L 307.5 267 L 318.5 264 Z M 317 267 L 315 268 L 315 269 L 319 268 L 317 267 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 273 Q 78.3 271.3 80 274.5 L 80 278.5 L 77.5 284 Q 72.3 285.3 71 282.5 L 70 274.5 L 71.5 273 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 273 L 291 276 L 284.5 279 Q 277.6 278.3 275 281 L 277.5 275 L 283.5 275 L 289.5 273 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 443.5 275 L 444 277.5 L 442.5 284 L 434 278.5 L 443.5 275 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 432.5 302 L 435.5 303 Q 440.3 303.3 442 306.5 L 443 312.5 L 440.5 320 L 423 315 L 425 307.5 L 429.5 303 L 432.5 302 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 323 L 286 324.5 L 284 325.5 L 285.5 323 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81 328 L 91 328.5 L 84.5 335 L 83 333.5 L 81 328 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 415.5 338 L 425 339 L 421.5 347 L 416 340.5 L 415.5 338 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 342 L 257 342.5 L 248.5 343 L 248.5 342 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 375 Q 120.8 373.9 120 376.5 L 116.5 384 L 111 377 L 117.5 375 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 408 Q 167.6 406.4 170 412.5 L 171 418.5 L 167.5 424 Q 164.8 426.8 158.5 426 L 153 421.5 L 152 414.5 L 155.5 409 L 157.5 408 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189 421 Q 195.7 421 199 425.5 L 198 432 Q 190.2 433.1 186 429.5 L 189 421 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(243,205,92)",
    stroke: "rgb(243,205,92)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 436 L 266 444.5 L 258 445 L 261.5 436 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,62,37)",
    stroke: "rgb(99,62,37)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 53 L 250 53 L 250 59.5 L 252 69.5 L 252 79.5 L 245.5 89 Q 239.7 92.7 228.5 91 L 221 85.5 L 218 78.5 L 216 57 Q 218.8 55.1 225 56 L 226 58.5 L 227 75.5 L 231.5 83 L 235.5 84 L 239.5 83 L 242 80.5 L 243 72.5 L 242 71.5 L 241 54 L 244.5 53 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,62,37)",
    stroke: "rgb(99,62,37)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 55 L 288.5 55 Q 296.1 56.5 300 61.5 L 298.5 65 L 293 67 Q 294.1 64.3 291.5 65 Q 289.2 61.2 282.5 62 L 275 67.5 L 273 74.5 L 276 82 Q 279 84.7 285.5 85 L 292.5 82 Q 296.6 84.3 297 89 Q 291.6 93.8 278.5 92 Q 270.6 89.9 267 83.5 Q 263.1 79.4 264 70.5 Q 265.5 62 271.5 58 L 278.5 55 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,62,37)",
    stroke: "rgb(99,62,37)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317 63 L 343 72 Q 343.8 77 340.5 79 L 329.5 74 L 323 73 L 321 78.5 L 336 85.5 L 333.5 91 L 318.5 86 L 316 92.5 L 333 100.5 L 330.5 106 L 304 95.5 L 317 63 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,62,37)",
    stroke: "rgb(99,62,37)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 65 Q 199.6 63.4 203 70.5 L 205 79.5 Q 203.5 86 198.5 89 L 187 94.5 L 190 103 L 182.5 106 L 169 72 L 187.5 65 Z M 189 72 L 181 75 L 184 86 L 193 84 L 196 80 L 195 76 Q 193 72 189 72 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,62,37)",
    stroke: "rgb(99,62,37)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 177 Q 173.8 175.8 175 178.5 L 175 186.5 L 172 192.5 L 173 197 Q 175.7 195.9 175 198.5 L 180 200.5 L 175 203 L 175 209.5 L 173 211.5 Q 174.5 217.5 171.5 219 L 167.5 212 L 160 206.5 L 161 192.5 L 161 190.5 L 162.5 184 L 163.5 186 L 168.5 177 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,62,37)",
    stroke: "rgb(99,62,37)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 220 L 363 221 L 366 229.5 L 362 232 L 361.5 229 L 359 230 L 360.5 220 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,62,37)",
    stroke: "rgb(99,62,37)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 230 Q 359.3 228.3 358 232.5 Q 361.6 233.9 361 239.5 L 358.5 241 L 354.5 240 L 351 236.5 Q 351.3 231.8 354.5 230 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,62,37)",
    stroke: "rgb(99,62,37)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 268 L 341 269.5 L 341.5 272 L 343 271.5 L 341.5 277 L 341 275 L 337 272.5 L 336 269 L 338.5 268 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,62,37)",
    stroke: "rgb(99,62,37)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 314 Q 285.8 313.3 285 315.5 L 286 317.5 L 283.5 322 L 278 317.5 Q 276.6 312.9 282.5 315 L 283.5 314 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 53 L 244 53.5 L 241 54 L 240.5 56 L 240 54.5 L 241.5 53 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 54 L 287 54.5 L 280.5 55 L 280.5 54 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 55 L 226 56.5 L 225.5 58 L 225 56 Q 221.7 56.8 222.5 55 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 57 L 251 59.5 L 250 59.5 L 250.5 57 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 58 L 297.5 60 L 296.5 58 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 66 L 252 68.5 L 251 68.5 L 251.5 66 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 67 L 201.5 69 L 200.5 67 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 72 L 191 72.5 L 188.5 73 L 188.5 72 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 80 L 239.5 83 L 241.5 80 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 81 L 192.5 84 L 194.5 81 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 83 L 249.5 85 L 250.5 83 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 267.5 84 L 271.5 89 L 267.5 84 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 84 L 286 84.5 L 283.5 85 L 283.5 84 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 86 L 297.5 88 L 296.5 86 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 334.5 90 L 333.5 92 L 334.5 90 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 91 L 237 91.5 L 231.5 92 L 231.5 91 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 92 L 287 92.5 L 283.5 93 L 283.5 92 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 332.5 99 L 333.5 101 L 332.5 99 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 124 L 271.5 124 L 288.5 127 L 301.5 131 Q 330.9 142.6 351 163.5 Q 370.2 183.3 381 211.5 L 386 229.5 L 387 242.5 L 388 243.5 L 388 270.5 L 384 291.5 L 373 318.5 Q 362.2 338.2 346.5 353 Q 325.5 373 294.5 383 L 271.5 388 L 240.5 388 L 213.5 382 L 189.5 371 Q 170.4 359.6 156 343.5 Q 138.4 323.6 129 295.5 L 124 271.5 L 124 239.5 L 128 219.5 L 139 192.5 Q 150.9 171.4 168.5 156 Q 181.9 144.4 198.5 136 L 219.5 128 L 240.5 124 Z M 167 176 L 162 181 L 163 184 L 162 183 L 159 188 L 160 190 L 161 193 L 160 196 L 161 200 L 158 202 L 160 205 L 159 207 L 162 209 L 159 214 L 158 224 L 156 229 Q 146 235 143 250 L 143 261 L 149 281 Q 156 296 167 307 L 180 318 L 207 333 L 235 342 L 255 343 L 256 344 L 268 341 L 280 334 L 284 329 Q 283 326 286 327 L 288 323 L 287 318 L 286 320 L 285 320 L 286 318 L 285 316 L 287 316 L 287 314 L 295 313 L 314 306 L 330 297 L 345 282 L 347 277 L 345 270 L 345 265 L 352 260 L 357 255 L 363 242 L 363 237 L 367 233 L 367 231 L 364 233 L 366 230 L 365 227 L 367 227 L 366 223 L 362 218 L 349 215 L 337 216 L 329 219 L 308 223 L 299 223 L 298 224 L 272 224 L 263 222 L 248 221 L 210 208 L 199 206 Q 192 201 189 193 L 190 190 L 188 183 L 179 177 L 175 176 L 175 178 L 167 176 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 180 L 176 184.5 L 175 184.5 L 175.5 180 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 187 L 173.5 189 L 174.5 187 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 190 L 173 192.5 L 172 192.5 L 172.5 190 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 198 L 181 200.5 L 179 201.5 L 179.5 200 Q 174.9 200.8 175.5 198 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 209 L 164.5 211 L 163.5 209 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 210 L 173.5 212 L 174.5 210 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 221 L 360 225.5 L 359 225.5 L 359.5 221 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 228 L 359 232.5 L 358 232.5 L 358.5 228 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 229 L 362 231.5 L 360 230.5 L 361.5 229 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 230 L 352.5 232 L 353.5 230 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 237 L 353.5 240 L 351.5 237 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 240 L 358 240.5 L 355.5 241 L 355.5 240 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 268 Q 342.8 267.3 342 269.5 L 342.5 273 L 340.5 268 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 314 L 283 314.5 L 280.5 315 L 280.5 314 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(134,76,52)",
    stroke: "rgb(134,76,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 319 L 280.5 321 L 279.5 319 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 53 L 240 56.5 L 239 56.5 L 239.5 53 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 56 L 227 60.5 L 226 60.5 L 226.5 56 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 58 L 268.5 60 L 269.5 58 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 59 L 216 61.5 L 215 61.5 L 215.5 59 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 60 L 241 65.5 L 240 65.5 L 240.5 60 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 60 L 252 62.5 L 251 62.5 L 251.5 60 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 61 L 302 63.5 L 299 65.5 L 301 62.5 L 300.5 61 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317.5 61 L 316.5 63 L 317.5 61 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 266.5 62 L 265.5 64 L 266.5 62 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 63 L 288 63.5 L 281.5 64 L 281.5 63 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 65 L 228 69.5 L 227 69.5 L 227.5 65 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 66 L 202.5 69 L 200.5 66 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 66 L 296.5 68 L 297.5 66 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 276.5 67 L 276 68.5 L 275.5 70 L 275 68.5 L 276.5 67 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 68 L 217 70.5 L 216 70.5 L 216.5 68 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 69 L 174 69.5 L 170.5 71 L 170.5 70 L 172.5 69 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 69 L 242 75.5 L 241 75.5 L 241.5 69 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 69 L 253 71.5 L 252 71.5 L 252.5 69 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 71 L 275 76.5 L 274 76.5 L 274.5 71 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 73 L 191 73.5 L 188.5 74 L 188.5 73 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 73 L 229 76.5 L 228 76.5 L 228.5 73 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 73 L 323.5 75 L 324.5 73 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 74 L 193.5 76 L 192.5 74 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 75 L 181.5 77 L 182.5 75 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 77 L 195 79.5 L 194 79.5 L 194.5 77 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322.5 77 L 324 79.5 L 322 78.5 L 322.5 77 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 80 L 239.5 82 L 240.5 80 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 81 L 192.5 83 L 193.5 81 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 83 L 186 85.5 L 184 84.5 L 184.5 83 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 266.5 84 L 270.5 89 L 266.5 84 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 84 L 297.5 87 L 295.5 84 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 93 L 189 94.5 L 188.5 96 L 188 94.5 L 189.5 93 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 102 L 190.5 104 L 191.5 102 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 105 L 184 106.5 L 181.5 107 L 180.5 105 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 115 L 272.5 115 L 289.5 118 L 302.5 122 Q 335.3 133.7 357 156.5 Q 374.9 174.6 386 199.5 L 392 216.5 L 397 242.5 L 397 244.5 L 397 270.5 Q 394.3 272.3 396 278.5 L 388 307.5 Q 374.5 341.5 348.5 363 Q 327 382.5 295.5 392 L 271.5 397 L 240.5 397 L 215.5 392 L 192.5 383 L 174.5 372 L 154 355 L 134 328.5 L 122 302.5 L 117 284.5 L 116 272.5 L 115 271.5 L 115 238.5 L 119 218.5 L 130 190.5 Q 141.3 168.8 158.5 153 Q 176.2 135.2 201.5 125 L 218.5 119 L 240.5 115 Z M 247 123 L 246 124 L 237 124 L 222 127 L 200 135 Q 180 144 167 158 L 164 160 Q 143 179 132 207 L 124 236 L 123 265 L 123 267 L 128 294 L 136 315 Q 145 332 158 346 L 160 349 L 165 352 L 166 355 L 184 368 L 205 379 L 227 386 L 237 388 L 246 388 L 247 389 L 276 388 L 300 382 Q 324 373 342 358 Q 366 338 379 308 L 387 281 L 388 266 L 389 265 L 389 252 L 389 250 L 388 249 L 388 240 L 387 239 L 386 228 L 380 208 Q 371 186 357 170 Q 337 146 308 133 L 291 127 L 276 124 L 247 123 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 176 L 181 179.5 L 179.5 180 L 174.5 177 L 174.5 176 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 191 L 184 193.5 L 181 194 L 182.5 191 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187 193 Q 189.7 191.9 189 194.5 L 196 205 L 205 208 L 206 213.5 Q 202.5 214 203 218.5 Q 216.6 230.4 235.5 237 L 252.5 241 Q 261.5 240 266.5 243 L 277.5 243 L 282.5 242 L 287.5 238 L 290 238 L 290.5 236 Q 291.7 238.3 296.5 237 L 302 236 L 303.5 233 L 306.5 233 L 313 228.5 L 314.5 225 L 322.5 226 L 332 219.5 L 330 218.5 L 331.5 218 L 335.5 219 L 339 217.5 L 338.5 216 L 340.5 217 L 342.5 217 L 345 218.5 L 340 221 L 341 227 L 331.5 229 L 322.5 234 L 302.5 241 L 295.5 242 L 292.5 244 L 275.5 246 L 275.5 245 L 281 244.5 L 273.5 244 L 270.5 246 L 253.5 246 L 231.5 241 Q 215.6 234.9 203.5 225 L 198.5 224 Q 196.8 227.1 195 225.5 Q 197 239 206.5 245 L 226.5 256 L 247.5 261 L 251.5 260 Q 253 262.5 258.5 261 L 263.5 260 L 267.5 261 L 283.5 255 L 287.5 255 L 291.5 251 L 298.5 249 L 319.5 237 L 324.5 236 L 327 237 L 328.5 234 L 329 235.5 L 328 239 L 332.5 238 Q 333 241.5 337.5 241 L 344.5 239 L 347 236.5 L 348 233 L 350.5 232 L 351 233.5 L 350 236.5 L 353.5 241 L 359 242.5 L 357 243 L 356 251.5 L 358 251.5 L 355 252.5 L 356 254.5 L 354 255.5 L 354.5 254 L 351 255.5 L 351.5 257 L 353 256.5 L 350.5 260 L 346.5 263 L 345 262.5 L 343.5 265 L 335 268 L 335 271.5 L 341.5 279 L 345 278.5 L 342 276.5 L 343 271 Q 345.7 269.9 345 272.5 L 346 275.5 L 346 277.5 L 345 280.5 L 327.5 298 L 315.5 304 L 314 303.5 L 313.5 305 L 312 304.5 L 311.5 306 L 310.5 305 Q 308.8 308.1 307 306.5 L 306.5 308 L 305.5 307 Q 303.8 310.1 302 308.5 Q 302.8 310.8 300.5 310 Q 299 307.5 297.5 311 L 293.5 312 L 291.5 311 L 291.5 313 L 288 312 L 286.5 315 L 282.5 313 L 275.5 315 L 262.5 315 L 261.5 316 L 258.5 315 L 248.5 315 L 247.5 314 L 236.5 313 L 219.5 308 Q 195.3 298.2 180 279.5 Q 173.5 272 170 261.5 L 169 245.5 L 171 240.5 L 172 230.5 L 170 219.5 L 171.5 220 Q 175.3 221.3 174 217.5 L 178 209.5 L 177 205 L 179.5 204 L 181.5 205 L 184.5 198 L 187 196.5 L 187 193 Z M 188 204 Q 189 214 195 221 L 198 222 L 199 217 L 197 215 L 190 206 L 188 204 Z M 183 209 L 182 215 L 185 225 L 186 225 L 186 221 L 183 209 Z M 188 229 Q 187 232 190 231 Q 191 228 188 229 Z M 189 236 L 186 241 L 176 237 L 173 243 L 175 245 L 173 245 L 173 250 Q 176 252 185 251 L 188 258 L 193 261 L 194 265 Q 193 267 196 266 L 198 274 L 203 277 L 204 277 L 204 281 L 210 282 L 225 290 L 227 287 Q 227 291 232 290 L 235 289 L 227 283 L 222 277 L 228 280 L 240 282 L 241 280 L 241 278 Q 244 277 243 281 L 245 282 Q 251 280 253 283 Q 259 280 270 282 L 275 278 Q 276 275 270 276 L 270 275 L 277 276 L 275 281 Q 278 278 285 279 L 291 276 L 290 273 L 284 275 L 278 275 Q 296 272 311 265 L 313 266 L 295 273 Q 292 272 293 275 L 300 273 L 302 273 L 306 272 L 308 273 L 328 272 L 330 271 L 330 268 L 328 264 L 323 264 L 335 263 L 332 261 L 331 258 L 327 256 L 328 253 L 327 251 L 328 247 L 320 249 L 316 252 Q 321 251 323 254 L 319 258 L 316 258 L 312 261 L 303 263 L 286 270 Q 279 269 277 272 L 269 272 L 268 273 L 258 273 L 256 273 L 239 270 L 237 270 L 235 269 L 232 270 L 234 270 L 234 271 Q 220 266 210 257 L 195 242 L 189 236 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 209 L 166 212.5 L 167 221.5 L 166 222.5 L 166 230.5 L 167 231.5 L 167 259.5 L 168 264.5 L 179.5 285 Q 181.8 284.3 181 286.5 L 184 291 L 197.5 302 L 215.5 313 L 221.5 313 L 235.5 318 L 245.5 318 L 259.5 321 L 268.5 318 L 276.5 318 Q 279 322.8 285 323 L 286.5 320 L 287 323.5 L 285 323.5 L 286 325.5 L 278.5 334 L 274.5 337 L 273 336.5 Q 273.8 338.8 271.5 338 L 263.5 342 L 261.5 341 L 257.5 343 L 256.5 342 L 248.5 342 L 244.5 343 L 228.5 340 L 207.5 333 Q 182 322.5 165 303.5 Q 153.1 290.9 147 272.5 L 148 270.5 L 146 270.5 L 144 262.5 L 144 247.5 L 146.5 241 L 147.5 243 L 153 234.5 L 148 237.5 L 156 228 L 158 227.5 L 157.5 226 L 159 225.5 L 159 223.5 Q 157.6 216.1 161 213.5 L 161 211.5 L 161.5 209 Z M 156 238 L 150 244 L 151 252 L 154 253 L 156 250 L 159 251 L 158 247 L 160 244 Q 163 245 161 241 L 156 238 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 218 Q 360.8 217.3 360 219.5 Q 358.5 222.5 357 219.5 L 358.5 218 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 222 L 258 222.5 L 254.5 223 L 254.5 222 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 222 L 313 222.5 L 309.5 223 L 309.5 222 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 357.5 222 L 358 227.5 L 357 227.5 L 357.5 222 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 263.5 223 L 266 223.5 L 263.5 224 L 263.5 223 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 223 L 307 223.5 L 302.5 224 L 302.5 223 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 224 L 282 224.5 L 271.5 225 L 271.5 224 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 290.5 224 L 298 224.5 L 290.5 225 L 290.5 224 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 228 L 356 228.5 L 350.5 231 L 347 229.5 L 354.5 228 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 232 L 364.5 233 L 366 232.5 L 362 234 L 363 236.5 L 361 235.5 L 360.5 232 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 240 L 362 242.5 L 360 241.5 L 361.5 240 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 264 L 318 264.5 L 315.5 265 L 315.5 264 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 267 L 319 267.5 L 312.5 270 L 312.5 269 L 316.5 267 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 273 L 244 273.5 L 241.5 274 L 241.5 273 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 274 L 250 274.5 L 245.5 275 L 245.5 274 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(222,161,65)",
    stroke: "rgb(222,161,65)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 275 Q 257 273.5 258.5 276 L 260.5 276 L 262.5 275 L 261.5 277 Q 254.7 276.1 252 278 L 251.5 275 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 52 L 248 52.5 L 244.5 53 L 244.5 52 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 54 L 251 56.5 L 250 56.5 L 250.5 54 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 55 L 222 55.5 L 218.5 56 L 218.5 55 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 56 L 216 58.5 L 215 58.5 L 215.5 56 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 56 L 241 59.5 L 240 59.5 L 240.5 56 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 57 L 267.5 62 L 271.5 57 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 58 L 299.5 61 L 297.5 58 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 61 L 227 64.5 L 226 64.5 L 226.5 61 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 63 L 252 65.5 L 251 65.5 L 251.5 63 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 64 L 196 64.5 L 188.5 65 L 188.5 64 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 64 L 275.5 68 L 278.5 64 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 290.5 64 L 293.5 68 L 290.5 64 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 299.5 64 L 298.5 66 L 299.5 64 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 65 L 217 67.5 L 216 67.5 L 216.5 65 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 65 L 242 68.5 L 241 68.5 L 241.5 65 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 66 L 295.5 68 L 296.5 66 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 69 L 203.5 71 L 202.5 69 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 70 L 228 73.5 L 227 73.5 L 227.5 70 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 71 L 168.5 73 L 169.5 71 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 263.5 71 L 264 75.5 L 263 75.5 L 263.5 71 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 72 L 253 78.5 L 252 78.5 L 252.5 72 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 74 L 218 76.5 L 217 76.5 L 217.5 74 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 74 L 243 76.5 L 242 76.5 L 242.5 74 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 76 L 206 78.5 L 205 78.5 L 205.5 76 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 78 L 322.5 80 L 321.5 78 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 79 L 278.5 83 L 275.5 79 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 80 L 231.5 83 L 229.5 80 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 81 L 294.5 84 L 292.5 81 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 84 L 199.5 89 L 203.5 84 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 84 L 336.5 86 L 335.5 84 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 85 L 224.5 90 L 220.5 85 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 85 L 246.5 89 L 249.5 85 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 92 L 283 92.5 L 280.5 93 L 280.5 92 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 106 L 332 106.5 L 329.5 107 L 329.5 106 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 123 L 266 123.5 L 246.5 124 L 246.5 123 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 124 L 240 124.5 L 236.5 125 L 236.5 124 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 124 L 276 124.5 L 272.5 125 L 272.5 124 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 136 L 196.5 138 L 194.5 139 L 195.5 137 L 197.5 136 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 139 L 323 141.5 L 321.5 141 L 319.5 139 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 141 L 187.5 143 L 185.5 144 L 186.5 142 L 188.5 141 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 326.5 143 L 327.5 145 L 326.5 143 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 144 L 181.5 147 L 178.5 149 L 180.5 146 L 183.5 144 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 145 L 330.5 147 L 329.5 145 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 332.5 147 L 333.5 149 L 332.5 147 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 149 L 175.5 151 L 176.5 149 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 150 L 338.5 153 L 336.5 150 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 152 L 169.5 156 L 172.5 152 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 153 L 348.5 162 L 340.5 153 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 160 L 158.5 166 L 163.5 160 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 164 L 356.5 170 L 351.5 164 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 169 L 152.5 173 L 155.5 169 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 172 L 361.5 176 L 358.5 172 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 175 L 148.5 178 L 150.5 175 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 175 L 172 175.5 L 166 179.5 L 163.5 185 L 162.5 183 L 159.5 191 L 160 189.5 L 159 187.5 L 162 180.5 L 166.5 176 L 168.5 176 L 170.5 175 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 176 L 177.5 179 L 179 178.5 L 178.5 177 L 179.5 180 L 182.5 180 L 188 183 L 190 189.5 L 189 192.5 L 190 194.5 L 189 194.5 Q 189.7 191.9 187 193 Q 188 196.8 185.5 198 L 183 199.5 Q 184 204 181.5 205 L 179.5 204 L 177 205 L 178 210.5 L 176 212.5 L 173.5 220 L 173 216.5 L 174 214.5 L 173 212.5 L 175 210.5 Q 173.5 204.5 176.5 203 L 181 200.5 L 174 196.5 L 173 189.5 Q 176.7 187.2 176 180.5 L 175 177.5 L 176.5 176 Z M 183 191 L 181 194 L 184 194 L 183 191 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 177 L 363.5 179 L 362.5 177 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 179 L 146.5 181 L 147.5 179 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 181 L 370 187.5 L 368 186.5 L 365.5 181 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 182 L 144.5 184 L 145.5 182 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 185 L 142.5 187 L 143.5 185 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 189 L 373 192.5 L 371 191.5 L 370.5 189 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 190 L 139.5 192 L 140.5 190 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 196 L 191.5 198 L 190.5 196 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 199 L 194.5 202 L 192.5 199 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 200 L 160 203.5 L 159 205.5 L 159.5 207 L 158 204.5 L 159 202.5 Q 156.8 201.3 159.5 200 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 204 L 190 205.5 L 196.5 215 L 199 216.5 L 197.5 222 L 195 221 Q 189.3 213.8 187.5 204 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 207 L 205 207.5 L 202.5 208 L 202.5 207 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 209 L 163.5 211 L 162.5 209 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 209 L 186 220.5 L 186 224.5 L 185 224.5 L 182 214.5 L 182.5 209 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 211 L 169 213 Q 168.8 217.5 172 219.5 L 170 219.5 L 172 234.5 L 169 245.5 L 169 256.5 L 175 272.5 L 192.5 292 Q 204.1 301.9 219.5 308 L 231.5 312 L 248.5 315 L 258.5 315 L 259.5 316 L 262.5 315 Q 272.8 316.3 279.5 314 L 279.5 315 Q 276.2 313.9 277 316.5 L 280.5 321 L 285 322.5 L 282.5 323 L 276.5 318 L 268.5 318 L 264.5 320 L 255.5 321 L 245.5 318 L 235.5 318 L 221.5 313 L 215.5 313 L 197.5 302 L 184 291 L 181 285 L 177 282.5 L 168 264.5 L 167 259.5 L 167 231.5 L 166 230.5 L 166 222.5 Q 168.8 220.8 167 214.5 L 165.5 211 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 213 L 160 215.5 L 159 215.5 L 159.5 213 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 215 L 349 215.5 L 342.5 216 L 342.5 215 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 217 L 159 223.5 L 156.5 228 L 156 226.5 Q 159.2 223.7 158.5 217 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360 218 L 362 218 Q 360.9 220.7 363.5 220 Q 366.8 221.8 367 226.5 L 365 225.5 L 361.5 220 L 359 221.5 Q 360.1 227.6 357.5 230 L 356.5 228 Q 359.5 228.5 358 221.5 L 360 218 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 220 L 322 220.5 L 319.5 221 L 319.5 220 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 221 L 253 221.5 L 249.5 222 L 249.5 221 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 222 L 263 222.5 L 258.5 223 L 258.5 222 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 266.5 223 L 271 223.5 L 266.5 224 L 266.5 223 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 223 L 302 223.5 L 298.5 224 L 298.5 223 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 224 L 290 224.5 L 282.5 225 L 282.5 224 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 229 L 149.5 236 L 155.5 229 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188 229 Q 191 228 190 231 Q 187 232 188 229 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 230 L 352 231.5 L 351.5 233 L 351 231.5 L 352.5 230 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 230 L 363 232.5 L 361 233 L 360.5 235 Q 357.8 233.8 359.5 230 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366.5 230 L 367 232.5 L 363 235.5 L 366.5 230 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 232 L 387 234.5 L 386 234.5 L 386.5 232 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 235 L 125 238.5 L 124 238.5 L 124.5 235 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 236 Q 364 237 363 241.5 L 362 241.5 L 361.5 236 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 238 Q 353.8 241.7 360 241.5 L 355.5 242 L 351.5 238 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 239 L 388 242.5 L 387 242.5 L 387.5 239 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 243 L 124 264.5 L 123 264.5 L 123.5 243 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 244 L 281 244.5 L 271.5 246 L 271.5 245 L 273.5 244 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 247 Q 328.8 245.9 328 248.5 L 327 250.5 L 328 252.5 L 327 256 L 331 257.5 L 332 261 L 335 262.5 L 315.5 264 L 283.5 274 L 263.5 276 L 261.5 276 L 259.5 275 L 257.5 275 Q 241.8 275.2 232 269.5 L 234.5 269 L 236.5 270 L 238.5 270 L 255.5 273 L 257.5 273 L 267.5 273 L 268.5 272 L 276.5 272 Q 279.4 269.4 285.5 270 L 302.5 263 L 311.5 261 L 315.5 258 L 318.5 258 L 323 253.5 Q 321.4 250.6 316 251.5 L 325.5 247 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 249 L 144 260.5 L 143 260.5 L 143.5 249 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 251 L 389 264.5 L 388 264.5 L 388.5 251 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 357.5 252 L 357 253.5 L 351.5 260 L 356 254.5 L 357.5 252 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 260 L 347.5 263 L 349.5 260 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 263 L 145 265.5 L 144 265.5 L 144.5 263 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 263 L 345 264.5 L 346 272.5 L 345 272.5 Q 345.8 270.3 343.5 271 L 342 268.5 L 342.5 267 L 338.5 268 L 339.5 266 L 345.5 263 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335 268 L 337 268.5 L 336 271.5 L 341.5 278 L 343.5 278 L 346 279.5 L 344.5 279 Q 338.8 279.8 338 275.5 Q 334.1 273.4 335 268 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 271 L 388 274.5 L 387 274.5 L 387.5 271 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 272 L 125 274.5 L 124 274.5 L 124.5 272 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 273 L 343 275.5 L 342 275.5 L 342.5 273 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 274 L 149 277.5 L 148 277.5 L 147.5 274 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 278 L 126 280.5 L 125 280.5 L 125.5 278 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 278 L 387 280.5 L 386 280.5 L 386.5 278 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 279 Q 154.9 293.1 165 302.5 L 160 298.5 Q 152.2 290.2 149.5 279 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 281 L 329.5 297 L 344.5 281 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 303 L 315.5 305 L 312.5 306 L 312.5 305 L 316.5 303 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 306 Q 178.2 317.8 193 325.5 L 191.5 325 Q 176.2 318 167.5 306 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 306 L 311 306.5 L 307.5 308 L 307.5 307 L 309.5 306 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 304.5 308 L 306 308.5 L 302.5 310 L 302.5 309 L 304.5 308 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 310 L 301 310.5 L 292.5 313 L 292.5 312 L 298.5 310 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 313 L 139 317.5 L 137 316.5 L 136.5 313 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 313 Q 286.5 312.5 287 315.5 L 284.5 314 Q 281.5 314.5 282.5 313 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 313 L 291 313.5 L 288.5 314 L 288.5 313 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 318 L 288 322.5 L 287 322.5 L 286.5 320 L 285 320.5 L 286.5 318 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 319 L 372 320.5 L 370.5 323 L 371 321.5 L 372.5 319 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 323 L 142.5 325 L 141.5 323 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 326 L 146 329.5 L 144 328.5 L 143.5 326 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 326 L 367.5 328 L 368.5 326 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 328 L 282.5 330 L 283.5 328 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366.5 329 L 365.5 331 L 366.5 329 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 331 L 148.5 334 L 146.5 331 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 332 L 279.5 334 L 280.5 332 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 332 L 362.5 335 L 364.5 332 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 334 L 275.5 337 L 277.5 334 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 335 L 151.5 338 L 149.5 335 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 336 L 359.5 339 L 361.5 336 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 340 L 155.5 343 L 153.5 340 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 341 L 237 341.5 L 234.5 342 L 234.5 341 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 357.5 341 L 354.5 345 L 357.5 341 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 342 L 262 342.5 L 259.5 343 L 259.5 342 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 348 L 163.5 352 L 160.5 348 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 353 L 341.5 358 L 345.5 353 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 355 L 172.5 360 L 168.5 355 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 359 L 335.5 363 L 338.5 359 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 360 L 186 368.5 L 184.5 368 Q 177 365.3 174.5 360 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 363 L 332.5 365 L 333.5 363 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 365 L 329.5 367 L 330.5 365 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 367 L 326.5 369 L 324.5 370 L 325.5 368 L 327.5 367 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 369 L 188.5 371 L 187.5 369 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322.5 370 L 321.5 372 L 319.5 373 L 320.5 371 L 322.5 370 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 386 L 281 386.5 L 278.5 387 L 278.5 386 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 387 L 240 387.5 L 236.5 388 L 236.5 387 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 387 L 276 387.5 L 272.5 388 L 272.5 387 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(169,115,38)",
    stroke: "rgb(169,115,38)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 388 L 265 388.5 L 246.5 389 L 246.5 388 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.42113b5eb8d13849fb006dc9a69ef40e.svg";
export { ForwardRef as ReactComponent };